<template>
<div class="a_infor" :class="{open:isOpen}">
    <p @click="isOpen=!isOpen">附件</p>
    <div class="box fj">
        <p v-if="canUpload">上传合同<span style="color:red">（必传）</span></p>
        <p v-else>合同附件</p>
        <div v-if="canUpload">
            <mt-button @click="ChooseFiles(1)" size="small" plain icon="upload">
                <img src="@/assets/upload.png" height="25" width="25" slot="icon">
                上传
            </mt-button><br />
            <span style="font-size: 10px;color: gray;">支持扩展名：.jpg .doc .pdf...</span>
        </div>
        <ul v-if="ContractList && ContractList.length > 0">
            <li v-for="(item, index) in ContractList" :key="index">
                <p class="longText">上传人：{{item.uploaderName}} 上传日期：{{getDateStr(item.createDateTime)}}</p>
                <p @click="GoToAttach(item)">
                    <span style="float: left;background: none;color: black;margin-left: 5px;padding: 0;">合同附件：</span>
                    {{item.displayName}}
                    <span class="ydd" v-if="deletable" @click="DeleteThis(item.index)">删除</span>
                </p>
            </li>
        </ul>
        <div class="clear"></div>
    </div>
    <div class="box fj">
        <p v-if="canUpload">法务邮件审批<span style="color:red">（必传）</span></p>
        <p v-else>法务邮件审批</p>
        <div v-if="canUpload">
            <mt-button @click="ChooseFiles(3)" size="small" plain icon="upload">
                <img src="@/assets/upload.png" height="25" width="25" slot="icon">
                上传
            </mt-button><br />
            <span style="font-size: 10px;color: gray;">支持扩展名：.jpg .doc .pdf...</span>
        </div>
        <ul v-if="LegalLit && LegalLit.length > 0">
            <li v-for="(item, index) in LegalLit" :key="index">
                <p class="longText">上传人：{{item.uploaderName}} 上传日期：{{getDateStr(item.createDateTime)}}</p>
                <p @click="GoToAttach(item)">
                    {{item.displayName}}
                    <span class="ydd" v-if="deletable" @click="DeleteThis(item.index)">删除</span>
                </p>
            </li>
        </ul>
        <div class="clear"></div>
    </div>
    <div class="box fj">
        <p v-if="canUpload">
            <span >营业执照附件</span>
            <span style="color:red">（必传）</span>           
        </p>
        <p v-else>营业执照附件</p>
        <div v-if="canUpload">
            <mt-button @click="ChooseFiles(4)" size="small" plain icon="upload">
                <img src="@/assets/upload.png" height="25" width="25" slot="icon">
                上传
            </mt-button><br />
            <span style="font-size: 10px;color: gray;">支持扩展名：.jpg .doc .pdf...</span>
        </div>
        <ul v-if="LicenseList && LicenseList.length > 0">
            <li v-for="(item, index) in LicenseList" :key="index">
                <p class="longText">上传人：{{item.uploaderName}} 上传日期：{{getDateStr(item.createDateTime)}}</p>
                <p @click="GoToAttach(item)">
                    {{item.displayName}}
                    <span class="ydd" v-if="deletable" @click="DeleteThis(item.index)">删除</span>
                </p>
            </li>
        </ul>
        <div class="clear"></div>
    </div>
    <div class="box fj">
        <p>其他附件</p>
        <div v-if="canUpload">
            <div style="display: flex;">
                <mt-button @click="ChooseFiles(2)" size="small" plain icon="upload">
                    <img src="@/assets/upload.png" height="25" width="25" slot="icon">
                    上传
                </mt-button>
                <div @click="ShouPup()" style="margin-left:5px; display: flex;background: #e0e0e0;border-radius: 1rem;">
                    <input style="background: #e0e0e0;border: 0;padding: 0.5rem 1rem;border-radius: 1rem;color: #595858; width: 70%;" readonly :value="attachType.className" />
                    <img src="@/assets/dropdown.png" width="18" height="13" style="margin-top: 10px;" />
                </div>
            </div>
            <span style="font-size: 10px;color: gray;">支持扩展名：.jpg .doc .pdf...</span>
        </div>
        <ul v-if="AttachFileList && AttachFileList.length > 0">
            <li v-for="(item, index) in AttachFileList" :key="index">
                <p class="longText">上传人：{{item.uploaderName}} 上传日期：{{getDateStr(item.createDateTime)}}</p>
                <p class="longText" @click="GoToAttach(item)">
                    <span style="float: left;background: none;color: black;margin-left: 5px;padding: 0;">{{item.typeName}}：</span>
                    {{item.displayName}}
                    <span class="ydd" v-if="deletable" @click="DeleteThis(item.index)">删除</span>
                </p>
            </li>
        </ul>
        <div class="clear"></div>
    </div>
    <input type="file" id="file-input" style="display:none"/>
    <mt-popup v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%;">
        <mt-picker :slots="slots" @change="onValuesChange" value-key="className" style="width: 100%;" showToolbar>
            <div class="picker-toolbar-title">
                <div class="mint-datetime-action mint-datetime-cancel" @click="popupVisible = !popupVisible">关闭</div>
                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmSelect">确定</div>
            </div>
        </mt-picker>
    </mt-popup>
</div>
</template>

<script>
import {
    Toast,
    Indicator,
    MessageBox
} from 'mint-ui';
import alioss from 'ali-oss';
import { encodeURIComponent } from 'utility';
export default {
    data() {
        return {
            LegalLit: [],
            LicenseList: [],
            ContractList: [],
            AttachFileList: [],
            uploadUserName: "",
            uploadContract: 0,
            isOpen: true,
            stsToken: null,
            AttachFile: null,
            tempAttachType: null,
            attachType: {
                className: "请选择附件类型",
                classItem: 0
            },
            slots: [{
                values: [],
            }],
            popupVisible: false,
        }
    },
    watch: {
        value: function (newOne, oldOne) {
            var that = this;
            that.ContractList = [];
            that.AttachFileList = [];
            that.LegalLit = [];
            that.LicenseList = [];
            if (that.value) {
                that.value.forEach((item, index) => {
                    if (item.type == 1) {
                        item.index = index;
                        that.ContractList.push(item);
                    }
                    if (item.type == 2) {
                        item.index = index;
                        that.AttachFileList.push(item);
                    }
                    if (item.type == 3) {
                        item.index = index;
                        that.LegalLit.push(item);
                    }
                    if (item.type == 4) {
                        item.index = index;
                        that.LicenseList.push(item);
                    }
                });
            }
        },
        contractList: function (newOne, oldOne) {
            var that = this;
            that.ContractList = newOne;
        },
        attachFileList: function (newOne, oldOne) {
            var that = this;
            that.AttachFileList = newOne;
        },
        legalList: function (newOne, oldOne) {
            var that = this;
            that.LegalLit = newOne;
        },
        licenseList: function (newOne, oldOne) {
            var that = this;
            that.LicenseList = newOne;
        },
    },
    created() {
        var that = this;
        if (that.canUpload) {
            that.userInfo = JSON.parse(sessionStorage.getItem("UserInfo"));
            if (that.userInfo) {
                that.uploadUserName = that.userInfo.name;
            }
        }
        that.GetAttachType();
    },
    props: ['canUpload', 'maxLength', 'value', 'contractList', 'attachFileList', 'deletable', 'legalList', 'licenseList', 'contractType','signType','approvalType'],
    methods: {
        GetAttachType() {
            var that = this;
            var code="RLWB_MATACHTYPE";
            console.log("contractType:"+that.contractType);
            that.$axios
                .get("/api/Common/GetResourceList?code="+code)
                .then(async (res) => {
                    if (res.data != null && res.data.isSuccess) {
                        that.slots[0].values = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        ShouPup() {
            this.popupVisible = true
        },
        onValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.tempAttachType = values[0];
            }
        },
        confirmSelect() {
            var that = this;
            this.popupVisible = false
            if (that.tempAttachType) {
                that.attachType = that.tempAttachType;
            }
        },
        getDateStr(date) {
            var d = new Date(date);
            var year = d.getFullYear();
            var month = (d.getMonth() + 1).toString();
            if (month.length == 1) {
                month = "0" + month;
            }
            var day = d.getDate().toString();
            if (day.length == 1) {
                day = "0" + day;
            }
            var hour = d.getHours().toString();
            if (hour.length == 1) {
                hour = "0" + hour;
            }
            var minute = d.getMinutes().toString();
            if (minute.length == 1) {
                minute = "0" + minute;
            }
            return `${year}-${month}-${day} ${hour}:${minute}`;
        },
        PushFiles() {
            var that = this;
            if(that.contractType==7 && that.uploadContract==1){
                //餐饮业务线合同
                if(that.AttachFile){
                    var patt=/\.(doc|DOC|docx|DOCX|xls|XLS|xlsx|XLSX|xlsm|XLSM|csv|CSV|ppt|PPT|pptx|PPTX|pdf|PDF|zip|ZIP|7z|7Z|rar|RAR)$/;
                    //gif|GIF|jpg|JPG|jpeg|JPEG|png|PNG
                    if(!patt.test(that.AttachFile.value)){
                        Toast("只能上传word, pdf和压缩包");
                        return;
                    }
                }
            }

            var file = that.AttachFile.files[0];
            document.querySelector('#file-input').setAttribute('type', 'text');
            document.querySelector('#file-input').setAttribute('type', 'file');
            if (that.uploadContract == 1) {
                if (that.ContractList.length >= that.maxLength) {
                    Toast(`最多支持上传${that.maxLength}个附件`);
                    return;
                }
            } else if (that.uploadContract == 2) {
                if (that.attachType == null || that.attachType.classItem == 0) {
                    Toast("请先选择附件类型");
                    return;
                }
                if (that.AttachFileList.length >= that.maxLength) {
                    Toast(`最多支持上传${that.maxLength}个附件`);
                    return;
                }
            } else if (that.uploadContract == 3) {
                if (that.LegalLit.length >= that.maxLength) {
                    Toast(`最多支持上传${that.maxLength}个附件`);
                    return;
                }
            } else if (that.uploadContract == 4) {
                if (that.LicenseList.length >= that.maxLength) {
                    Toast(`最多支持上传${that.maxLength}个附件`);
                    return;
                }
            }
            var size = file / 1024;
            if (size > 10240) {
                Toast("附件大小不能超过10M");
                return;
            }

            var position= file.name.lastIndexOf(".");
            var fileNameSpit = file.name.split(".");
            var fileExt = fileNameSpit[fileNameSpit.length - 1];
            var now = new Date();
            var timestamp = now.getTime();
            var year = now.getFullYear();
            var month = (now.getMonth() + 1).toString();
            if (month.length == 1) {
                month = "0" + month;
            }
            var day = now.getDate().toString();
            if (day.length == 1) {
                day = "0" + day;
            }
            var lengthName =file.name.substring(0,position);  //fileNameSpit[0];
            MessageBox.prompt('请输入附件名称', {
                inputValue: lengthName,
                inputValidator:(val)=>{
                    if(val==null){
                        return true;
                    }
                    return (val!='');
                },
                inputErrorMessage:"附件名称不能为空！"
            }).then(({
                value
            }) => {
                if (!value) {
                    value = lengthName;
                } else {
                    value = value.trim();
                    if (value.length > 20) {
                        value = value.substring(0, 20);
                    }
                }

                var client = new alioss({
                    region: that.stsToken.region,
                    accessKeyId: that.stsToken.accessKeyId,
                    accessKeySecret: that.stsToken.accessKeySecret,
                    stsToken: that.stsToken.securityToken,
                    endpoint: that.stsToken.endpoint,
                    bucket: that.stsToken.bucket
                });
                var folderName = `${that.stsToken.envPath}/Biz/${year}-${month}-${day}`;
                var fileName = `${value}_${timestamp}.${fileExt}`;
                Indicator.open('上传中');
                client.multipartUpload(`${folderName}/${fileName}`, file, {
                        progress: async function (a, b) { //上传进度回调;
                            console.log("progress " + a);
                            //console.log(b);
                        }
                    })
                    .then(function (res) {
                        Indicator.close();
                        if (res.res.statusCode === 200) {
                            that.value.push({
                                type: that.uploadContract,
                                folderName: folderName,
                                fileName: fileName,
                                displayName: value,
                                uploaderName: that.uploadUserName,
                                createDateTime: new Date(),
                                typeCode: that.uploadContract != 2 ? "" : that.attachType.classItem,
                                typeName: that.uploadContract != 2 ? "" : that.attachType.className
                            });
                        } else {
                            Toast("上传失败");
                            console.log(res);
                        }
                    })
                    .catch(function (err) {
                        Indicator.close();
                        Toast("上传失败");
                        console.log(err);
                    });

            });

        },
        ChooseFiles(type) {
            var that = this;
            that.uploadContract = type;
            var fileInput = document.getElementById("file-input");
            that.AttachFile = fileInput;
            fileInput.addEventListener("change", that.PushFiles, false);
            that.stsToken = JSON.parse(sessionStorage.getItem("STSToken"));
            if (!that.stsToken || !that.stsToken.accessKeyId || new Date(that.stsToken.expiration) < new Date()) {
                that.$axios
                    .get("/api/Common/GetOssSTSToken")
                    .then((res) => {
                        if (res.data != null && res.data.isSuccess) {
                            that.stsToken = res.data.data;
                            sessionStorage.setItem("STSToken", JSON.stringify(that.stsToken));
                            fileInput.click();
                        } else {
                            console.log(res.data.message);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                fileInput.click();
            }
        },
        DeleteThis(index) {
            var that = this;
            MessageBox.confirm('', {
                title: '提示',
                message: '确定要删除此附件吗?',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(action => {
                that.value.splice(index, 1);
            }).catch(error => {
                return;
            });
        },
        GoToAttach(item) {
            var that = this;
            if (!that.canUpload) {
                var filename=encodeURIComponent(item.fileName).replace(/!/g,'%21').replace(/'/g,'%27').replace(/\(/g,'%28').replace(/\)/g,'%29').replace(/\*/g,'%2A').replace(/%20/g,'+');
                var url=`${process.env.VUE_APP_CDN_BASE_URL}/${item.folderName}/${filename}`
                window.open(url);
            }
        },
    }
}
</script>
